const getBase64FileFormat = (base64String: string) => {
	// Extract the part before the base64 data
	const mimeType = base64String.split(';')[0];
	// Extract the file format from the MIME type
	const format = mimeType.split('/')[1];
	return format;
};
export { getBase64FileFormat };
